import React from 'react';
import { ResponsiveLayout } from '@/components/ResponsiveLayout';
import WarRoomHQ from '@/components/WarRoomHQ';

export default function WarRoomHQPage() {
  return (
    <ResponsiveLayout>
      <div className="flex flex-col min-h-screen bg-[hsl(var(--background))] text-[hsl(var(--text-primary))]">
        <header className="sticky top-0 z-30 bg-[hsl(var(--surface))]/95 backdrop-blur-md border-b border-[hsl(var(--border))]">
          <div className="px-4 lg:px-6 py-3 lg:py-4">
            <h1 className="text-lg lg:text-xl font-bold tracking-tight text-[hsl(var(--text-primary))]">War Room</h1>
            <p className="text-xs text-[hsl(var(--text-muted))]">Command Center — All Channels Diagnostics</p>
          </div>
        </header>
        <div className="flex-1 overflow-y-auto overflow-x-hidden">
          <WarRoomHQ />
        </div>
      </div>
    </ResponsiveLayout>
  );
}
